import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 411.05 329.3"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M410.4 117.2c.6 0 1.3.4-.5 1.9-2.6 2.1-8.9 7.2-11.7 9.5-2.3 1.8-3.9 2.4-7.3 3.1-102.8 15.7-193 50.1-193 84.9 0 18.3 53.9 38 106.9 51.5 1.4.4 1.8.9 2.2 1.5 1 1.8 2.4 4.4 2.8 5.1.5.9.6 2.2-1.1 2-96.8-12-186.4-26.7-186.4-69.6 0-3.9.3-7.8 1.4-11.8 12.2-43.5 143.1-74.2 278.4-77.9 2.8-.07 5.57-.13 8.3-.2Z",
      style: {"fill":"#1b1d80","fill-rule":"evenodd"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M253.2 329.3h-88.7c-56.2 0-112.3-34.8-164.5-182.2h44c10 0 14.5-4.4 17.7-8.4 24.6-34 79.3-109.3 85.8-118.1C159.7 4.1 166.6 0 198.2 0h182.6c3.9 0 2.8 2-.2 2.9C246.8 39.1 139.5 116.3 123.5 196c-11 54.6 58.7 113.5 129 131.1 3.2.9 1.9 2.2.7 2.2Z",
      style: {"fill-rule":"evenodd","fill":"#df0011"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "MU-logo"}) } }